import { jsx as _jsx } from "react/jsx-runtime";
import { SelectRequest } from '@src/components/Employee/PaymentRequests/SelectRequest';
import { FullPageWrapper } from '@src/components/FullPageWrapper';
import { useParams } from 'react-router-dom';
export const SelectPaymentRequest = () => {
    const { id } = useParams();
    const programId = id ? parseInt(id, 10) : undefined;
    return _jsx(FullPageWrapper, { children: programId && _jsx(SelectRequest, { programId: programId }) });
};
